import { render, staticRenderFns } from "./purchase-orders.vue?vue&type=template&id=3e2b520b&scoped=true&"
import script from "./purchase-orders.vue?vue&type=script&lang=js&"
export * from "./purchase-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2b520b",
  null
  
)

export default component.exports